import { createContext, useContext } from 'react';
import { SuggestionSearchBarContextData as ContextData } from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useSuggestionSearchBarContext = () => useContext(context);
